import MapboxDraw, { DrawCustomMode, DrawModeChangeEvent } from "@mapbox/mapbox-gl-draw";
import { Feature, Polygon } from "geojson";
import { defer } from "lodash";

import polygonSelect from "../base/polygonSelect";

import { addDrawFeature, TOO_MANY_FEATURES_THRESHOLD } from "./helper";

/**
 * This is a custom draw mode that allows for the user to select existing draw features on the map
 * or to select features from the selectableSourceLayer.
 *
 * Selection of features is by drawing a polygon on the map.
 */
const ctsPolygonSelect: DrawCustomMode = {
  ...polygonSelect,

  // We override the onDraw function to select features using rBush instead of the queryRenderedFeatures method.
  // This allows for selection of features that are not currently rendered on the map
  // (e.g. due to zoom level or because they are outside of the current viewport)
  onDraw: function (this: MapboxDraw.DrawCustomModeThis, polygon: Feature<Polygon>) {
    const features = this._ctx.options.getFeaturesInBoundary?.(polygon) || [];

    features.forEach((feature) => {
      this.addDrawFeature?.(feature);
    });

    // We defer to allow the onDraw to complete prior to firing the mode change and selection change events, which allows the draw features to be included in the selection.
    defer(() => {
      if (features.length > TOO_MANY_FEATURES_THRESHOLD) {
        this._ctx.options.onSelectionLimitExceeded?.(features.length);
      } else {
        this.changeMode("simple_select", { featureIds: features.map((f) => f.id) });
        this.map?.fire("draw.modechange", { type: "draw.modechange", mode: "simple_select" } as DrawModeChangeEvent);
        this.map?.fire("draw.selectionchange", { features });
      }
    });
  },

  addDrawFeature,
} as DrawCustomMode;

export default ctsPolygonSelect;
